import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import App from './App';
import Cookies from 'js-cookie';
import { Config } from './other';
import * as serviceWorker from './serviceWorker';
import { initialize } from '@braze/web-sdk';

//redux
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import Reducers from './store/reducers';
import rootReducer from './store/reducers/rootReducer';
import { adminAuthSet, adminAuthSetManual, adminLogout } from './store/actions';
import { initSplitSdk, getTreatments } from '@splitsoftware/splitio-redux';
import { composeWithDevTools } from '@redux-devtools/extension';

//configuracion default de axios
axios.defaults.timeout = 300000; //seteo el timeout de los requests
axios.defaults.withCredentials = true;

const sdkBrowserConfig = {
  core: {
    authorizationKey: Config.SPLIT_IO_BROWSER_API_KEY,
    key: Config.REACT_APP_NAME,
  },
};

const lowEnvironments = Config.ENVIRONMENTS.filter(
  (env) => env !== 'production'
);

const composeEnhancers = lowEnvironments.includes(Config.REACT_APP_ENVIRONMENT)
  ? composeWithDevTools(applyMiddleware(thunk))
  : applyMiddleware(thunk);

const store = createStore(rootReducer, composeEnhancers);

// list of split names
const FF_SPLITS = [
  'experiment_empretienda_panel_onboarding',
  'feature_flag_empretienda_panel_aplicaciones',
  'feature_flag_empretienda_panel_mi_plan_debito_automatico',
];

store.dispatch(initSplitSdk({ config: sdkBrowserConfig }));
store.dispatch(getTreatments({ splitNames: FF_SPLITS }));

//chequeo beta data
if (localStorage.getItem('bdata')) {
  store.dispatch({
    type: Reducers.BETA_GUARDAR,
    data: JSON.parse(localStorage.getItem('bdata')),
  });
}

//checkeo login status
if (Config.USE_HEADER) {
  if (localStorage.getItem('token') && localStorage.getItem('auth')) {
    axios.defaults.headers.common['Authorization'] =
      'Bearer ' + localStorage.getItem('token');
    store.dispatch(adminAuthSet());
  } else {
    store.dispatch(adminLogout());
  }
} else {
  if (Cookies.get('is_auth')) {
    if (localStorage.getItem('auth')) {
      store.dispatch(adminAuthSet());
    } else {
      store.dispatch(adminAuthSetManual());
    }
  } else {
    store.dispatch(adminLogout());
  }
}

initialize(Config.BRAZE_API_KEY, {
  enableSdkAuthentication: true,
  baseUrl: Config.BRAZE_API_ENDPOINT,
  enableLogging: Config.BRAZE_API_DEV_MODE,
});

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
